import React, { useState, useRef } from 'react';
import { CompareFaces } from '../services/api';

export default function FaceDetect() {
  const [initialized, setInitialized] = useState(true);
  const [message, setMessage] = useState('Loading models...');
  const [matchPercentage, setMatchPercentage] = useState(null);

  const imgRef1 = useRef();
  const imgRef2 = useRef();
  const canvasRef1 = useRef();
  const canvasRef2 = useRef();

  // Load models


  const [image1Base64, setimage1Base64] = useState(null);
  const [image2Base64, setimage2Base64] = useState(null);

  const image1Base64Upload = async (e, imgRef) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setimage1Base64(reader.result);
      };
      reader.readAsDataURL(file); // converts to Base64
    }
    // const image = await faceapi.bufferToImage(file);


    //setimage1Base64(image.src);

  }
  const image2Base64Upload = async (e, imgRef) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setimage2Base64(reader.result);
      };
      reader.readAsDataURL(file); // converts to Base64
    }
    // const image = await faceapi.bufferToImage(file);
    // setimage2Base64(image.src);
  }

  const compareFacesPlus = async () => {
    console.log('kkkkk');
    
    const formData = new FormData();
    // formData.append("api_key", "8bfs8s3iqGGS86j5UlFVAG2gLkqi5MXj");
    // formData.append("api_secret", "01AAUu15Sf4hQFLsXCkjKSYzeEvpQ_xn");
    formData.append("image_base64_1", image1Base64);
    formData.append("image_base64_2", image2Base64);

    try {
      const response = await CompareFaces(formData);
      console.log(response);


    } catch (error) {
      // console.error("Error:", error);
      console.log("Registration failed. Please try again.");
    }
    // const res = await fetch("https://api-cn.faceplusplus.com/facepp/v3/compare", {
    //   method: "POST",
    //   body: formData,
    // });

    // const data = await res.json();
    // console.log(data.confidence); // Score out of 100
  };
  return (
    <>
      <div className="grid grid-flow-col grid-rows-3 gap-4">
        <div className="row-start-1 row-end-4"><h2 className="text-2xl font-bold mb-4">Face Detect</h2></div>

      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-4">

        <div className="face-recognition">
          <h2>Face Recognition</h2>
          <p>{message}</p>

          <div className="image-container">
            <div>
              <input
                type="file"
                onChange={(e) => image1Base64Upload(e, imgRef1)}
                accept="image/*"
              />
              <img ref={imgRef1} style={{ display: 'none' }} alt="Image 1" />
              <canvas ref={canvasRef1} />
            </div>

            <div>
              <input
                type="file"
                onChange={(e) => image2Base64Upload(e, imgRef2)}
                accept="image/*"
              />
              <img ref={imgRef2} style={{ display: 'none' }} alt="Image 2" />
              <canvas ref={canvasRef2} />
            </div>
          </div>

          <button className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors" onClick={compareFacesPlus} disabled={!initialized}>
            Compare Faces
          </button>

          {matchPercentage !== null && (
            <div className="result">
              <h3>Match Percentage: {matchPercentage}%</h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
